<template>
  <DashboardBaseSidebar :is-sidebar-shown="isSidebarShown" @close="emitClose">
    <DashboardAdminSidebarHub @navigate="emitNavigate" />
  </DashboardBaseSidebar>
</template>

<script setup lang="ts">
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';

  // Components
  import DashboardBaseSidebar from '~/modules/dashboard/sidebar/base/DashboardBaseSidebar.vue';
  import DashboardAdminSidebarHub from '~/modules/dashboard/admin/sidebar/hub/DashboardAdminSidebarHub.vue';

  defineProps({
    isSidebarShown: {
      type: Boolean,
      required: true,
    },
  });

  const emit = defineEmits<{
    (e: 'navigate', route: RouteLocationNormalizedLoaded | string): void;
    (e: 'close'): void;
  }>();

  const emitNavigate = (route: RouteLocationNormalizedLoaded | string) => emit('navigate', route);

  const emitClose = () => emit('close');
</script>
